var _style, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryMobileStuff = function SvgCategoryMobileStuff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_mobile_stuff_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_mobile_stuff_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_stuff_svg__st0",
    d: "m18.2 22.3 3.5-8.4h5.7l3.4 8.4h-7.1zM21.5 31.4l1.9-2.1c.1-.1.2-.2.4-.2h1.5c.1 0 .2.1.4.1l2 2.1c.3.3.1.8-.4.8h-5.4c-.5.1-.7-.4-.4-.7zM23.7 28.7v-6.1M25.3 28.7v-6.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "category_mobile_stuff_svg__st0",
    cx: 28,
    cy: 26.1,
    r: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_stuff_svg__st0",
    d: "M28 22.3v2.6"
  })));
};
export default SvgCategoryMobileStuff;